import { render } from "./ApplicationComponent.vue?vue&type=template&id=6708011c&scoped=true"
import script from "./ApplicationComponent.vue?vue&type=script&lang=js"
export * from "./ApplicationComponent.vue?vue&type=script&lang=js"

import "./ApplicationComponent.vue?vue&type=style&index=0&id=6708011c&scoped=true&lang=css"
import "./ApplicationComponent.vue?vue&type=style&index=1&id=6708011c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6708011c"]])

export default __exports__